function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.0013 0.333496H2.0013C1.26797 0.333496 0.667969 0.933496 0.667969 1.66683V12.3335C0.667969 13.0668 1.26797 13.6668 2.0013 13.6668H10.0013C10.7346 13.6668 11.3346 13.0668 11.3346 12.3335V3.66683L8.0013 0.333496ZM2.0013 12.3335V1.66683H7.33464V4.3335H10.0013V12.3335H2.0013ZM8.66797 5.66683V9.00016C8.66797 10.4735 7.47464 11.6668 6.0013 11.6668C4.52797 11.6668 3.33464 10.4735 3.33464 9.00016V4.66683C3.33464 3.68683 4.17464 2.90683 5.17464 3.00683C6.0413 3.0935 6.66797 3.88683 6.66797 4.76016V9.00016H5.33464V4.66683C5.33464 4.48016 5.18797 4.3335 5.0013 4.3335C4.81464 4.3335 4.66797 4.48016 4.66797 4.66683V9.00016C4.66797 9.7335 5.26797 10.3335 6.0013 10.3335C6.73464 10.3335 7.33464 9.7335 7.33464 9.00016V5.66683H8.66797Z",
  fill: "#7E7D82"
});

var SvgIcClip = function SvgIcClip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_clip.12f98053.svg";
export { ForwardRef as ReactComponent };